import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1'


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }
  
  state = {
    detailList : [],
    editId : -1
   }

   setDetailList(data){

      this.setState(prevState => {
        return {
          detailList : data,
          editId : -1
        }
      })

   }

   editDetail(id){
    this.setState(prevState => {
      return {
        editId : id
      }
    })
  }

    newEvent(){
      this.setState(prevState => {
        return { 
          detailList : [{Id:0 ,Description:'', Tag:''}],
          editId : 0
        }
      })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

   }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
             <div class="register_panel login_panel">
               <div class="container">
                 <div class="register_panel--section form-register">
                   <form action="/login" method="post" class="form login">
                     <input type="hidden" name="_token" value="2gm1lbIXwdKQDyOOjdM0xAN5kvIzQiFt5m4lxudX"/> 
                     <div class="form-body"><div class="register-section">
                       <span class="label">اگر در بیت کالا حساب ندارید، ثبت نام کنید:</span>
                        <a href="/register?plan=0" class="btn btn-info">ایجاد حساب کاربری</a>
                        </div>
                         <div class="form-group">
                           <label for="panel" class="label-control label-control-extra">اگر در بیت کالا حساب کاربری دارید، وارد شوید : </label> 
                           <input type="text" name="email" placeholder="ایمیل خود را وارد کنید" class="form-control "/>
                           </div> 
                           <div class="form-group">
                             <div class="password-box">
                               <input type="password" name="password" placeholder="پسورد خود را وارد کنید" class="form-control "/> 
                               <a href="https://roocket.ir/password/reset" class="forgot-password">فراموش کردید؟</a>
                                <i class="far passwordShow-toggle fa-eye-slash"></i>
                                </div>
                                </div>
                                 <div class="form-group token">
                                   <div data-sitekey="6LdCGY4UAAAAAPd15TuUr76dpRyeCRcE1aSZEBwy" class="g-recaptcha">
                                     <div style={{width: 304, height: 78}}>
                                       <div>
                                         <iframe src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LdCGY4UAAAAAPd15TuUr76dpRyeCRcE1aSZEBwy&amp;co=aHR0cHM6Ly9yb29ja2V0LmlyOjQ0Mw..&amp;hl=fa&amp;v=NMoy4HgGiLr5NAQaEQa2ho8X&amp;size=normal&amp;cb=sxki8lapi3sj" width="304" height="78" role="presentation" name="a-2eh47qisy3bb" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"></iframe>
                                      </div>
                                      <textarea id="g-recaptcha-response" name="g-recaptcha-response" class="g-recaptcha-response amin-force" ></textarea>
                                      </div>
                                      <iframe style={{display:NaN}}>


                                        
                                      </iframe>
                                      </div>
                                      </div> 
                                      <div class="form-group w-25">
                                        <button type="submit" id="submit_button" class="btn btn-info">ورود</button>
                                        </div>
                                        </div> <div class="loginWith">
                                          <div class="quick-login">
                                            <a href="https://roocket.ir/login/google" class="link google">
                                              <i class="fab fa-google"></i> ورود سریع با حساب گوگل</a>
                                               <a href="https://roocket.ir/login/yahoo" class="link yahoo">
                                                 <div class="yahoo-btn">!Y</div> ورود سریع با حساب یاهو</a>
                                                 </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                    </div>

      </>
    )
  }
}


